







import { defineComponent, ref, inject, onMounted } from '@vue/composition-api'

// Store
import { StoreKey as InputStoreKey } from '@/store/Input'

type Props = {
    name: string
    id: string
    classname: string
}

export default defineComponent({
    inheritAttrs: false,
    props: {
        name: { type: String, required: false },
        id: { type: String, required: false },
        classname: { type: String, required: false },
    },
    setup(props: Props) {
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }

        const value = ref<string | string[]>('')
        onMounted(() => {
            value.value = inputStore.get_value(props.name)
        })

        return {
            value,
        }
    },
})
